import React, { Component } from 'react';
import Sidebar from '../../Component/sidebar/sidebar';
import Header from '../../Component/header/Header';
import SubQa from '../../Component/sub-QA-QC/subQa';

export class Qc extends Component {
  render() {
    return (
        <div className="container">
        <div className="row row-cols-2">
          {/* SIDEBAR DESIGN */}
          <div className="col-2 sidebar">
              <Sidebar />
          </div>
  
          {/* CONTENT DESIGN */}
          <div className="col-10 content">
            <Header title={"QA-QC"}/>
            {/* users section */}
            <SubQa />
          </div>
        </div>
      </div>
    )
  }
}

export default Qc;